import { Component, Input, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { NotificacionesService } from '../../../../../../services/generar-pedido/cart/notifications/notificaciones.service';

@Component({
  selector: 'app-span-legend',
  templateUrl: './span-legend.component.html',
  styleUrls: ['./span-legend.component.scss']
})
export class SpanLegendComponent implements OnInit {
  public content: string;
  public display: string;
  public justifyContent: string
  private unsubscribe$ = new Subject<void>();
  @Input() mensaje: string;
  @Input() where: string;

  constructor(
    private notificacion: NotificacionesService,
  ) { }

  ngOnInit() {
    this.reload();
  }
  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
  ngOnChanges() {
    this.reload();
  }
  reload() {
    this.notificacion.legends.pipe(takeUntil(this.unsubscribe$)).subscribe((legends: any) => {
      if (legends) {
        //console.log("LEGENDSSSSSSS", legends);
        if (legends.length > 0) {
          //console.log("first if")
          legends.forEach((legend: any) => {
            if (this.mensaje === legend.id) {
              //console.log(this.mensaje, "===", legend.id);
              this.content = legend.content;
              this.display = legend.display;
              this.justifyContent = legend.justify_content;

            }
          });
        } else {
          //console.log("MENSAJE legends", this.mensaje)
          switch (this.mensaje) {
            case 'legend_1':
              this.content = 'El tiempo de entrega estimado para articulos del almacen CDMX son 3 a 5 días hábiles.';
              break;
            case 'legend_2':
              this.content = 'El tiempo de entrega estimado para articulos del almacen CDMX son 3 a 5 días hábiles.';
              break;
            case 'legend_3':
              this.content = 'Si este pedido no se factura dentro de 48 horas se cancelara de manera automática.';
              break;

            case 'legend_4':
              this.content = 'Estimado cliente Por favor omitir su régimen capital, Ejemplo: Mi Empresa SA DE CV cambiar por Mi Empresa';
              break;
            case 'legend_9':
              this.content = 'No hay artículos en tu carrito. Agrega algunos productos si deseas hacer una compra.'
              break;
          }
        }
      } else {
        switch (this.mensaje) {
          case 'legend_1':
            this.content = 'El tiempo de entrega estimado para articulos del almacen CDMX son 3 a 5 días hábiles.';
            break;
          case 'legend_3':
            this.content = 'Si este pedido no se factura dentro de 48 horas se cancelara de manera automática.';
            break;

          case 'legend_4':
            this.content = 'Estimado usuario, Por favor omitir su régimen capital, Ejemplo: Mi Empresa SA DE CV cambiar por Mi Empresa';
            break;
        }
      }
    });
  }
}
